const initialState = {
    filters: [],
    AllChats: [],
    AllNLP: [],
    perday: []
};

const rootReducers = (state = initialState, action) => {

    switch (action.type) {
        case "manipulatefilters": {
            const { filtername, value } = action.payload;

            const filterExists = state.filters.some(
                (filter) => filter.filtername === filtername
            );

            let updatedFilters;

            if (filterExists) {
                updatedFilters = state.filters.filter(
                    (filter) => filter.filtername !== filtername
                );
            } else {
                updatedFilters = [
                    ...state.filters,
                    { filtername, value }
                ];
            }

            return { ...state, filters: updatedFilters };
        }

        case "clearfilters": {
            return { ...state, filters: [] };
        }


        case "populateChats": {
            return { ...state, AllChats: action.payload };
        }


        case "populateNLP": {
            return { ...state, AllNLP: action.payload };
        }

        case "populateChatUsage": {
            return { ...state, perday: action.payload };
        }


        case 'UPDATE_FEEDBACK':
            return {
                ...state,
                AllChats: state.AllChats.map((log) =>
                    log.FileName === action.payload.id
                        ? { ...log, moderatorfeedback: action.payload.moderatorfeedback, technicalFeedback: action.payload.technicalFeedback }
                        : log
                ),
            };


        default:
            return state;
    }
};


export default rootReducers;